"use client";

import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-4 w-24 bg-muted/30 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const shopLinks = [{
  label: "Shop All",
  to: "/ShopPage"
}, {
  label: "Current Drop",
  to: "/ShopPage"
}, {
  label: "Limited Editions",
  to: "/ShopPage"
}, {
  label: "Gift Cards",
  to: "#"
}];
const atelierLinks = [{
  label: "Our Mission",
  to: "/AboutImpactPage"
}, {
  label: "Our Causes",
  to: "/CurrentCausesPage"
}, {
  label: "Impact Report",
  to: "/AboutImpactPage"
}, {
  label: "Transparency",
  to: "/AboutImpactPage"
}];
const serviceLinks = [{
  label: "Contact Us",
  to: "#"
}, {
  label: "Shipping Policy",
  to: "#"
}, {
  label: "Returns",
  to: "#"
}, {
  label: "FAQ",
  to: "#"
}];
export default function Footer() {
  return <section data-section-id="231" id="community-footer" className="bg-background text-foreground relative overflow-hidden pt-30 pb-12 px-6 md:px-12">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 left-0 right-0 w-full overflow-hidden select-none">
        <div className="font-serif text-primary/10 leading-none whitespace-nowrap tracking-tighter text-center" style={{
        fontSize: "clamp(8rem, 22vw, 18rem)"
      }}>
          FOREVER FRESH
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {}
          <div className="space-y-5">
            <Link to="/" className="inline-block">
              <span className="font-serif text-3xl tracking-tight text-foreground">
                FOREVER FRESH
              </span>
            </Link>
            <p className="font-default text-sm leading-relaxed text-foreground/70 max-w-xs">
              Keeping awareness issues forever fresh in people’s minds through purpose-driven design.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs uppercase tracking-[0.2em] text-primary mb-6">
              Shop
            </h3>
            <ul className="space-y-3">
              {shopLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs uppercase tracking-[0.2em] text-primary mb-6">
              Mission
            </h3>
            <ul className="space-y-3">
              {atelierLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-xs uppercase tracking-[0.2em] text-primary mb-6">
              Support
            </h3>
            <MenuProvider menu_id="23">
              <FooterMenuConsumer />
            </MenuProvider>
            <ul className="space-y-3 mt-3">
              {serviceLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <Separator className="my-12 bg-primary/30" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <p className="font-default text-[10px] uppercase tracking-[0.2em] text-foreground/60 order-2 md:order-1">
            &copy; 2025 FOREVER FRESH &middot; Awareness through action
          </p>

          {}
          <div className="flex items-center gap-6 order-1 md:order-2">
            <Link to="#" newTab aria-label="Instagram" className="text-primary hover:text-foreground transition-colors duration-300">
              <Instagram strokeWidth={1} className="size-5" />
            </Link>
            <Link to="#" newTab aria-label="Twitter" className="text-primary hover:text-foreground transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="size-5" aria-hidden="true">
                <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
              </svg>
            </Link>
            <Link to="#" newTab aria-label="TikTok" className="text-primary hover:text-foreground transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="size-5" aria-hidden="true">
                <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
              </svg>
            </Link>
          </div>

          {}
          <div className="order-3 flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-foreground/60 font-default">
            <span>Global</span>
            <span className="text-primary/50">/</span>
            <span>USD $</span>
          </div>
        </div>
      </div>
    </section>;
}